import Footer from "./common/Footer";
import { Link } from "react-router-dom";
// import Profile from "./common/Profile";
import level1Data from "../data/level1.json";
import HeaderDashboard from "./common/HeaderDashboard";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";

const courses = ["head", "neck", "chest", "abdomen", "limbs"]
const scale = Math.min(
  window.innerWidth / 380,
  (window.innerHeight - 180) / 650
);

function CourseCard({ isOpen, info }) {
  return (
    <div className="course-card">
      <div
        className={
          "card p-0 border-0 rounded-3 position-relative h-100 " +
          (isOpen ? "bg-blue2" : "bg-gray4")
        }
      >
        <div className="card-body d-flex justify-content-center align-items-center">
          <div className="image">
            <img
              className="card-img-top img-fuild"
              src={`/icons/${info.slug}.svg`}
              alt={info.name}
            />
          </div>
        </div>
        {isOpen > 0 ? (
          <Link
            className="card-footer bg-blue1 border-0 rounded-bottom-3 text-center text-black text-decoration-none active stretched-link"
            to={`/${info.slug}?fromDashboard=true`}
          >
            <span className="fs-5 fw-bolder">{info.name}</span>
            <br />
            Open
          </Link>
        ) : (
          <div className="card-footer bg-gray3 border-0 rounded-bottom-3 text-center text-gray1">
            <span className="fs-5 fw-bolder">{info.name}</span>
            <br />
            Coming soon
          </div>
        )}
      </div>
    </div>
  )
}
function BodyParts() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [hovered, setHovered] = useState("");
  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    text: ""
  });

  const parts = [
  {
    id: "head",
    label: "Head",
    src: "/icons/body/head.png",
    enabled: true,
    style: {
      left: "141px",
      top: "-3px",
      width: "99px"
    }
  },
  {
    id: "neck",
    label: "Neck",
    src: "/icons/body/neck.png",
    enabled: true,
    style: {
      left: "125px",
      top: "90px",
      width: "131px"
    }
  },
  {
    id: "chest",
    label: "Chest",
    src: "/icons/body/chest.png",
    enabled: true,
    style: {
      left: "105px",
      top: "144px",
      width: "171px",
       zIndex: 30
    }
  },
  {
    id: "abdomen",
    label: "Abdomen",
    src: "/icons/body/abdomen.png",
    enabled: true,
    style: {
      left: "109px",
      top: "288px",
      width: "162px",
       zIndex: 30
    }
  },
  {
    id: "upper-limbs",
    label: "Upper Limbs",
    src: "/icons/body/upper-limbs.png",
    enabled: true,
    style: {
      left: "3px",
      top: "146px",
      width: "374px",
      zIndex: 20
    }
  },
  {
    id: "lower-limbs",
    label: "Lower Limbs",
    src: "/icons/body/lower-limbs.png",
    enabled: true,
    style: {
      left: "104px",
      top: "395px",
      width: "173px",
      zIndex: 20
    }
  }
];

  const handleClick = (part) => {
    switch (part) {
      case "abdomen":
        navigate("/abdomen");
        break;

      case "chest":
        navigate("/chest");
        break;

      default:
        break;
    }
  };

  return (
    <>
     <div className="w-25">
                    <h2 className="fw-bold text-black">{user.firstName}'s Dashboard</h2>
                    <h5 className="fw-bolder text-gray2">{user.role}</h5>
                </div>
    <div
     /*  style={{
        position: "relative",
        width: "100%",
        maxWidth: "auto",
        height: "776px",
        justifyContent: "center",
        display: "flex",
        textAlign: "center"
      }} */
    //  className="d-flex flex-row pt-4 justify-content-between align-items-center"
     className="body-wrapper d-flex"
      style={{ top: "-60px"}}
    >
         <div
            /* style={{
              position: "absolute",
              inset: 0,
              left: 0,
              right: 0,
              margin: "0 auto",
              top: 0,
              width: "380px",
            }} */
          className="body-container"
          // style={{ transform: `scale(${scale})` }}
          >
              {/* Overlay Parts */}
              {parts.map((part) => (
                <img
                  key={part.id}
                  src={part.src}
                  alt={part.label}
                  onClick={() => part.enabled && handleClick(part.id)}
                  onMouseMove={(e) => {
                    if (!part.enabled) return;

                    setHovered(part.id);
                    setTooltip({
                      visible: true,
                      x: e.clientX,
                      y: e.clientY,
                      text: part.label
                    });
                  }}
                  onMouseLeave={() => {
                    setHovered("");
                    setTooltip({
                      visible: false,
                      x: 0,
                      y: 0,
                      text: ""
                    });
                  }}
                  style={{
                    position: "absolute",
                    ...part.style,
                    // opacity: hovered === part.id ? 0.55 : 0,
                    mixBlendMode: hovered === part.id ? "hard-light" : "",
                    transition: "opacity .2s",
                    cursor: part.enabled ? "pointer" : "default",
                    objectFit: "cover",
                    pointerEvents: part.enabled ? "auto" : "none"
                  }}
                />
              ))}
      </div>
    </div>
    </>
  );
}
function Dashboard() {
  return (
    <div className="w-100 h-100 bg-green5 overflow-hidden">
      <HeaderDashboard />
      <main className="main-section body-main-section mx-4 rounded-top-3 bg-white overflow-hidden">
        <div className="container-fluid">
          <div className="d-flex flex-column pt-3">
            
              {/* {courses.map((course, courseIndex) => {
                return (
                  <CourseCard
                    key={courseIndex}
                    isOpen={
                      Array.isArray(level1Data[course])
                        ? level1Data[course][0]?.children?.length > 0
                        : level1Data[course]?.children?.length > 0
                    }
                    info={
                      Array.isArray(level1Data[course])
                        ? level1Data[course][0]
                        : level1Data[course]
                    }
                  />
                );
              })} */}
              <BodyParts />
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}

export default Dashboard;
